// extracted by mini-css-extract-plugin
export var button = "_1i-0";
export var buttonContent = "_1i-e";
export var buttonGroup = "_1i-c";
export var dontRestrainIconWidth = "_1i-a";
export var dropdownButton = "_1i-b";
export var iconContainer = "_1i-9";
export var lg = "_1i-4";
export var md = "_1i-3";
export var pending = "_1i-f";
export var sm = "_1i-2";
export var spinner = "_1i-d";
export var squared = "_1i-8";
export var wrapText = "_1i-g";
export var xl = "_1i-5";
export var xs = "_1i-1";
export var xxl = "_1i-6";
export var xxxl = "_1i-7";